import { AfterViewInit, Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserSurveyApi } from '@api/services/user-survey-api';
import { UserSurveyResponseStatus } from '@api/models/user-survey-response-status';
import { TallySurveyService } from '@core/services/tally-survey.service';

export interface SurveyDialogData {
  formId: string;
  userId: number;
  customerId?: number;
}

@Component({
  selector: 'flow-survey-dialog',
  templateUrl: './survey-dialog.component.html',
  styleUrls: ['./survey-dialog.component.scss'],
})
export class SurveyDialogComponent implements AfterViewInit, OnDestroy {
  embedSrc: string;
  private stopListening: () => void;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SurveyDialogData,
    private dialogRef: MatDialogRef<SurveyDialogComponent>,
    private tallySurveyService: TallySurveyService,
    private userSurveyApi: UserSurveyApi
  ) {
    const params = new URLSearchParams({
      uID: String(this.data.userId ?? ''),
      cID: String(this.data.customerId ?? ''),
      hideTitle: '1',
      dynamicHeight: '1',
    });
    this.embedSrc = `https://tally.so/embed/${this.data.formId}?${params.toString()}`;
  }

  ngAfterViewInit(): void {
    this.tallySurveyService.loadEmbeds();
    this.stopListening = this.tallySurveyService.listenForSubmission(this.data.formId, () => {
      this.userSurveyApi.updateUserSurveyStatus({ userId: this.data.userId, status: UserSurveyResponseStatus.Completed }).subscribe();
      this.dialogRef.close();
    });
  }

  onNotNowClick(): void {
    this.userSurveyApi.updateUserSurveyStatus({ userId: this.data.userId, status: UserSurveyResponseStatus.Dismissed }).subscribe();
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.stopListening?.();
  }
}
